import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  fill: "none",
  viewBox: "0 0 76 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#999",
      "stroke-linecap": "round",
      "stroke-miterlimit": "4.139",
      "stroke-width": "5",
      d: "M5 38 38 6l33 32"
    }, null, -1)
  ])))
}
export default { render: render }